import RulesTable from './RulesTable';

export { RulesTable };
export default RulesTable;
